module.exports = __webpack_public_path__ + "static/media/home-inactive.4c173737.svg";